import { memo } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { Chip, SelectItem, TmdxSelect } from '@ds';
import { AdminFormRow } from '@ui';
import { EMPLOYEE_ORGAN_LIST_LEGACY } from '@lp/features/admin/forms/config';
import { EmployeeFormValues, SelectItemType } from '@/types';

type OrganTypeSelectorProps = {
  isReadOnly?: boolean;
};

export const OrganTypeSelector = memo(({ isReadOnly }: OrganTypeSelectorProps) => {
  const { control, setValue } = useFormContext<EmployeeFormValues>();
  const contractorCertifications = useWatch({ control, name: 'contractorCertifications' });

  return (
    <AdminFormRow title="Organ">
      <Controller
        name="organType"
        control={control}
        render={({ field: { value, ref, onChange, ...field }, fieldState: { invalid, error } }) => (
          <TmdxSelect
            items={EMPLOYEE_ORGAN_LIST_LEGACY}
            variant="bordered"
            isMultiline
            selectionMode="multiple"
            placeholder="Select an organ"
            labelPlacement="outside"
            aria-label="Organ"
            isInvalid={invalid}
            isDisabled={isReadOnly}
            errorMessage={error?.message}
            selectedKeys={value}
            onSelectionChange={(keys) => {
              const organsList = Array.from(keys);
              onChange(organsList);
              if (contractorCertifications?.length) {
                setValue(
                  'contractorCertifications',
                  contractorCertifications.filter((c) => organsList.includes(c.organType)),
                );
              }
            }}
            {...field}
            renderValue={(items) => {
              const organTypes = items.map((item) => item.data) as SelectItemType[];
              return (
                <div className="flex flex-wrap gap-2">
                  {organTypes.map((item) => (
                    <Chip key={item.value}>{item.name}</Chip>
                  ))}
                </div>
              );
            }}
          >
            {(item) => {
              const selectItem = item as SelectItemType;
              return (
                <SelectItem textValue={selectItem.name} key={selectItem.value}>
                  <div className="flex gap-2 items-center">
                    <span className="text-small">{selectItem.name}</span>
                  </div>
                </SelectItem>
              );
            }}
          </TmdxSelect>
        )}
      />
    </AdminFormRow>
  );
});
